import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_ADMIN_SUBSCRIPTIONS_LIST_API_ID =
  'DASHBOARD/FETCH_ADMIN_SUBSCRIPTIONS_LIST_API_ID';

const apiCall = createApiCall(
  FETCH_ADMIN_SUBSCRIPTIONS_LIST_API_ID,
  params => ({
    endpoint: generateEndpoint({
      host: `/api/admin/subscriptions`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
